import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GanttLoaderService {

  private api = (window as any);

  startGantt(config: any): void {
    this.api.startGantt(config);
  }
  setLoad(): void {
    this.api.setLoad();
  }
  removeLoad(): void {
    this.api.removeLoad();
  }
  setModalAlert(type, text, extraMsg = null, func = null): void {
    this.api.setModalAlert(type, text, extraMsg = null, func = null);
  }
}